import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { useEffect, useState, useContext } from "react";
import service from "../services/authservices";
import { toast } from "react-toastify";
import { UserContext } from "../contexts/UserContext";
import { ScaleLoader } from "react-spinners";
import Modal from "@mui/material/Modal";
import moment from "moment";
import Box from "@mui/material/Box";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

const Support = () => {
  const [faqs, setFaqs] = useState({});
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [supportdata, setsupportdata] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { theme } = useContext(UserContext);
  const characterLimit = 100; // Set your character limit
  const [errors, setErrors] = useState({
    subject: "",
    selectedCategory: "",
    message: "",
  });
  const [supportHistory, setSupportHistory] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  useEffect(() => {
    fetchSupportHistory();
    fetchFaqs();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleOpen = (data) => {
    setOpen(true);
    setsupportdata(data ? data : "");
    // console.log("data-->>", supportdata);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchFaqs = async () => {
    try {
      const response = await service.getFaq();
      if (response.status) {
        const withdrawFaqs = response.data.filter(
          (faq) => faq.type === "Support"
        );
        setFaqs(withdrawFaqs);
      } else {
        console.error("Failed to fetch FAQs");
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const fetchSupportHistory = async () => {
    try {
      setLoading(true);
      const response = await service.getsupport();
      if (response.status) {
        setSupportHistory(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Failed to fetch support history");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching support history:", error);
    }
  };
  const categoryOptions = [
    { value: "Deposit", label: "Deposit" },
    { value: "Withdraw", label: "Withdraw" },
    { value: "Upgrade", label: "Upgrade" },
  ];

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " . . .";
    }
    return text;
  };

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      boxShadow: "none",
      outline: "none",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
    }),
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const validateSubject = (value) => {
    let errorMessage = "";
    if (!value.trim()) {
      errorMessage = "Subject is required.";
    } else if (value.length < 5) {
      errorMessage = `Subject cannot below 5 characters.`;
    } else if (value.length > characterLimit) {
      errorMessage = `Subject cannot exceed ${characterLimit} characters.`;
    }
    setErrors((prevErrors) => ({ ...prevErrors, subject: errorMessage }));
    return errorMessage;
  };

  const validateCategory = (value) => {
    let errorMessage = "";
    if (!value) {
      errorMessage = "Please select a category.";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      selectedCategory: errorMessage,
    }));
    return errorMessage;
  };

  const validateMessage = (value) => {
    let errorMessage = "";
    if (!value.trim()) {
      errorMessage = "Message is required.";
    } else if (value.length < 3) {
      errorMessage = "Message cannot below 3 characters";
    } else if (value.length > 250) {
      errorMessage = "Message cannot exceed 250 characters";
    }
    setErrors((prevErrors) => ({ ...prevErrors, message: errorMessage }));
    return errorMessage;
  };

  const handleSubjectChange = (e) => {
    const value = e.target.value.trimStart();
    setSubject(value);
    validateSubject(value);
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    validateCategory(selectedOption); // Validate on change
  };

  const handleMessageChange = (e) => {
    const value = e.target.value.trimStart();
    setMessage(value);
    validateMessage(value); // Validate on change
  };

  const handleSubmit = async () => {
    const subjectError = validateSubject(subject);
    const categoryError = validateCategory(selectedCategory);
    const messageError = validateMessage(message);

    // If any error exists, return early
    if (subjectError || categoryError || messageError) {
      return;
    }

    // Clear previous errors
    setErrors({
      subject: "",
      selectedCategory: "",
      message: "",
    });

    setLoading(true);

    const data = {
      Subject: subject,
      text: message,
      Category: selectedCategory.value,
      image: "", // Handle file uploads if necessary
      video: "", // Handle file uploads if necessary
    };

    try {
      const response = await service.support(data);
      if (response.status) {
        showSuccessToast(
          "Ticket raised successfully! Our team will get back to you soon."
        );
        // Reset form
        setSubject("");
        setMessage("");
        setSelectedCategory(null);
        fetchSupportHistory();
      } else {
        showErrorToast("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting support ticket:", error);
      showErrorToast("Failed to submit the ticket. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section>
        <Header />
      </section>

      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("Support")}</span>
              <div className="row mt-4">
                <div className="col-lg-7">
                  <div className="deposit_left_main">
                    <div className="depo_inner_divmain">
                      <label htmlFor="subject" className="support-label">
                        {t("Subject")}
                      </label>
                      <input
                        type="text"
                        maxLength="100"
                        placeholder={t("EnterTheSubject")}
                        className="bind_bin_next_inp"
                        id="subject"
                        value={subject}
                        onChange={handleSubjectChange}
                      />

                      {/* Error message for subject */}
                      {errors.subject && (
                        <span className="error">{errors.subject}</span>
                      )}
                    </div>

                    <div className="depo_inner_divmain">
                      <label
                        htmlFor="select-category"
                        className="support-label"
                      >
                        {t("SelectCategory")}
                      </label>
                      <Select
                        styles={customStyles}
                        placeholder={t("SelectTheCategory")}
                        className="withdraw-dropdown-menu w-100"
                        options={categoryOptions}
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        // onChange={(selectedOption) => {
                        //   setSelectedCategory(selectedOption);
                        //   // Clear the error message once the user selects a category
                        //   setErrors((prevErrors) => ({ ...prevErrors, selectedCategory: "" }));
                        // }}
                      />
                      {/* Error message for category */}
                      {errors.selectedCategory && (
                        <span className="error">{errors.selectedCategory}</span>
                      )}
                    </div>

                    <div className="depo_inner_divmain">
                      <label htmlFor="message" className="support-label">
                        {t("Message")}
                      </label>
                      <textarea
                        placeholder={t("EnterTheMessage")}
                        className="bind_bin_next_inp support_textarea"
                        id="message"
                        value={message}
                        maxLength="250"
                        fluid
                        rows="5"
                        onChange={handleMessageChange}
                        // onChange={(e) => {
                        //   const value = e.target.value;
                        //   const sanitizedValue = value.trimStart();
                        //   setMessage(sanitizedValue);
                        //   setErrors((prevErrors) => ({ ...prevErrors, message: "" }));
                        // }}
                      ></textarea>
                      {/* Error message for message */}
                      {errors.message && (
                        <span className="error">{errors.message}</span>
                      )}
                    </div>

                    <div className="w-100">
                      <button
                        className="support-btn"
                        onClick={handleSubmit}
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="container m-top-20 p-0">
                    <div
                      class="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      <div className="faq">
                        <h5 className="faq-title">{t("FAQs")}</h5>
                        {/* {faqs.length > 0 ? (
                          faqs.map((faq, index) => (
                            <div
                              className="accordion-item font-satoshi"
                              key={faq._id}
                            >
                              <h2
                                className="accordion-header"
                                id={`flush-heading-${index}`}
                              >
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#flush-collapse-${index}`}
                                  aria-expanded="false"
                                  aria-controls={`flush-collapse-${index}`}
                                >
                                  {index + 1}. {faq.question}
                                  <span className="icon">
                                    <i className="fas fa-chevron-down"></i>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse-${index}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`flush-heading-${index}`}
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  {faq.status === "Active"
                                    ? faq.answer
                                    : "Content not available."}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="faq2">
                            <span className="faq_cate_span">
                              No FAQs available for Support.
                            </span>
                          </div>
                        )} */}
                        {faqs.length > 0 ? (
                          faqs.map((faq, index) => (
                            <div
                              className="accordion-item font-satoshi"
                              key={faq._id}
                            >
                              <h2
                                className="accordion-header"
                                id={`flush-heading-${index}`}
                              >
                                <button
                                  className={`accordion-button ${
                                    activeIndex === index ? "" : "collapsed"
                                  }`}
                                  type="button"
                                  onClick={() => handleToggle(index)}
                                  aria-expanded={
                                    activeIndex === index ? "true" : "false"
                                  }
                                  aria-controls={`flush-collapse-${index}`}
                                >
                                  {index + 1}. {faq.question}
                                  <span className="icon">
                                    <i
                                      className={`fas ${
                                        activeIndex === index
                                          ? "fa-chevron-up"
                                          : "fa-chevron-down"
                                      }`}
                                    ></i>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse-${index}`}
                                className={`accordion-collapse collapse ${
                                  activeIndex === index ? "show" : ""
                                }`}
                                aria-labelledby={`flush-heading-${index}`}
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  {faq.status === "Active"
                                    ? faq.answer
                                    : "Content not available."}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="faq2">
                            <span className="faq_cate_span">
                              {t("NoFAQsAvailableForSupport")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="recent_depo_main">
                <div className="manage_btn_row">
                  <span className="home_right_marketspan">
                    {t("SupportHistory")}
                  </span>
                  <Link to="/supporthistory">
                    <div className="d-flex align-items-center gap-2 cursor-pointer">
                      <span className="home_starty_view">{t("ViewAll")}</span>
                      <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                    </div>
                  </Link>
                </div>

                <div className="recent_depo_tablemain pb-0">
                  <div className="table-responsive table-borderless home_recent_table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>{t("TicketID")}</th>
                          <th>{t("Date&Time")}</th>
                          <th>{t("Subject")}</th>
                          <th>{t("Category")}</th>
                          <th>{t("Status")}</th>
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          // Show loader when data is being fetched
                          <tr>
                            <td colSpan="5" className="text-center">
                              <div className="loader_main loader_mainChange">
                                <ScaleLoader
                                  color="#20A1FD"
                                  height={10}
                                  width={3}
                                />
                                <p>{t("Loading")}</p>
                              </div>
                            </td>
                          </tr>
                        ) : supportHistory.length > 0 ? (
                          supportHistory.slice(0, 5).map((ticket) => (
                            <tr key={ticket._id}>
                              <td>
                                <span>{ticket._id.slice(0, 10)}</span>
                              </td>
                              <td>
                                <span>{ticket.created_at}</span>
                              </td>
                              <td className="table-flex">
                                {truncateText(ticket.subject, 15)}
                              </td>
                              <td>
                                <span>{ticket.category}</span>
                              </td>
                              <td>
                                <span>
                                  {ticket.status === "0" ? "Open" : "Closed"}
                                </span>
                              </td>
                              <td className="table_center_text  text-white">
                                <button
                                  class="action_btn"
                                  onClick={() => handleOpen(ticket)}
                                >
                                  {t("View")}
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              {t("NoSupportTicketsFound")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modals_support">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 support-modal">
                      <div>
                        <div className="support-left-flex">
                          <h5 className="support-modal-title">
                            {t("Details")}
                          </h5>
                          <i
                            className="fa-regular fa-circle-xmark cross_circle"
                            onClick={handleClose}
                          ></i>
                        </div>

                        <div className="">
                          <div className="support-modal-top">
                            <h6 className="">{t("TicketID")}</h6>
                            <p className="">
                              {supportdata?._id
                                ? supportdata._id.slice(0, 10)
                                : ""}
                            </p>
                          </div>

                          <div className="support-modal-top">
                            <h6 className="">{t("Subject")}</h6>
                            <p className="">{supportdata?.subject || "N/A"}</p>
                          </div>

                          <div className="support-modal-top">
                            <h6 className="">{t("Message")}</h6>
                            <p>{supportdata?.message || "N/A"}</p>
                          </div>

                          <div className="support-modal-top">
                            <h6 className="">{t("Category")}</h6>
                            <p className="">{supportdata?.category || "N/A"}</p>
                          </div>

                          <div className="support-modal-top">
                            <h6 className="">{t("Date&Time")}</h6>
                            <p className="">
                              {supportdata?.created_at
                                ? supportdata.created_at
                                : "N/A"}
                            </p>
                          </div>

                          <h5 className="support-modal-title">
                            {t("SupportReply")}
                          </h5>
                          {supportdata?.reply != null ? (
                            supportdata?.reply.length > 0 ? (
                              supportdata?.reply.map((rep) => (
                                <>
                                  <div className="support-modal-top">
                                    <h6 className="">{t("ReplyMessage")}</h6>
                                    <p className="">{rep?.message || "N/A"}</p>
                                  </div>

                                  <div className="support-modal-top">
                                    <h6 className="">{t("ReplyAttachment")}</h6>
                                    <p className="">
                                      {rep?.image ? (
                                        <img src={rep?.image} />
                                      ) : (
                                        "N/A"
                                      )}
                                    </p>
                                  </div>

                                  <div className="support-modal-top">
                                    <h6 className="">{t("RepliedOn")}</h6>
                                    <p className="">
                                      {moment(rep?.posted_at).format("lll")}
                                    </p>
                                  </div>
                                </>
                              ))
                            ) : (
                              <div className="support-modal-top">
                                <h6 className="">{t("NoReplyFound")}</h6>
                              </div>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
